'use strict';

import { loadComponent } from './utils/load-component';

loadComponent(
    'digital-archive-filter',
    {
    props: [],
    data: function() {
        return {
            ViewModel: {
                Groups: []
            },
            filters: {}
        };
    },
    methods: {
        clearForm: function() {
            Object.keys(this.filters).forEach(key => {
                this.filters[key] = [];
            });
            this.filterChanged();
        },
        filterChanged: function() {
            const newURL = new URL(document.location);

            for (const key in this.filters) {
                newURL.searchParams.delete(key);
                for (let index = 0; index < this.filters[key].length; index++) {
                    newURL.searchParams.append(key, this.filters[key][index]);
                }
            }

            history.pushState(this.filters, null, newURL.toString());
            this.$root.$emit('DigitalArchiveFilters.filtersUpdated', this.filters);
        },
        updateFilters: function(filters) {
            // Pass updated Filters from DigitalArchiveList?
            this.ViewModel.Groups = filters;
            const searchParams = new URLSearchParams(document.location.search);
            this.filters = filters.reduce((carry, filter) => {
                carry[filter.ID] = searchParams.getAll(filter.ID);
                return carry;
            }, {});

            this.filterChanged();
        }
    },
    beforeMount: function() {
        this.$root.$on('DigitalArchive.updateFilters', this.updateFilters);
    },

    mounted: function() {}
});
